import { ForUser, ForDevice } from 'types';
import { SaleWaterType, type SalesItem } from './types';

export const getUrl = ({ deviceId, userId }: ForDevice | ForUser) =>
  deviceId ? `/device/${deviceId}` : `/${userId}`;

export const isMineralSale = (sale: SalesItem) =>
  sale.IsMineral || sale.WaterType === SaleWaterType.Mineral;
